import { StrictMode } from 'react'
import './i18n'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'


// /で始まる内部リンクにベースパスを自動付与
const base = __BASE_PATH__.replace(/\/$/, '');
if (base) {
  document.addEventListener('click', (e) => {
    const a = (e.target as HTMLElement).closest('a');
    if (!a) return;
    const href = a.getAttribute('href');
    if (!href || !href.startsWith('/') || href.startsWith(base + '/') || href === base) return;
    if (href.startsWith('//')) return;
    e.preventDefault();
    window.location.href = base + href;
  });
}
createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
